import React, { useContext, useState } from "react";
import { createContext } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "./auth/AuthContext";
function useTitle() {
  const { authState } = useContext(AuthContext);
  const isClient = authState.user?.userName === "Counterparty";
  const { t } = useTranslation(isClient ? "client" : "translation");
  const [title, setStateTitle] = useState<string>(t("home"));

  function setTitle(propsTitle: string) {
    setStateTitle(t(propsTitle));
  }
  return {
    title,
    setTitle,
  };
}
export const TitleContext = createContext({} as ReturnType<typeof useTitle>);
export function TitleProvider(props: any) {
  return <TitleContext.Provider {...props} value={useTitle()} />;
}
